import { map } from "../fable_modules/fable-library.3.7.17/Set.js";
import { createObj, comparePrimitives } from "../fable_modules/fable-library.3.7.17/Util.js";
import { MarginLeft, MarginBottom, PaddingRight, PaddingLeft, PaddingBottom, PaddingTop, modal, flexExpand, Gap, BkgColor } from "../../../Styles/Utils.fs.js";
import { createElement } from "react";
import * as react from "react";
import { Feliz_prop__prop_fss_Static_72C268A9 } from "../fable_modules/Fss-lib.Feliz.1.0.3/FssFeliz.fs.js";
import { unitHelpers_CssRuleWithAutoLength__value_Z498FEB3B } from "../fable_modules/Fss-lib.Core.1.0.4/Types/Units.fs.js";
import { px } from "../fable_modules/Fss-lib.Core.1.0.4/Functions.fs.js";
import { MaxWidth } from "../fable_modules/Fss-lib.Core.1.0.4/css/ContentSize.fs.js";
import { empty, ofArray, singleton } from "../fable_modules/fable-library.3.7.17/List.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.1.2.6/./Mui.fs.js";
import Chip from "@material-ui/core/Chip";
import { Interop_reactApi } from "../fable_modules/Feliz.1.68.0/./Interop.fs.js";
import { Row, Col } from "../../../Components/UtilComponents.fs.js";
import Paper from "@material-ui/core/Paper";
import { FlexClasses_FlexShrinkGrow__value_5E38073B } from "../fable_modules/Fss-lib.Core.1.0.4/Types/Flex.fs.js";
import { FlexGrow } from "../fable_modules/Fss-lib.Core.1.0.4/css/Flex.fs.js";
import { DisplayData, InfoTitle } from "../../../DesignSystems/DesignSystem.fs.js";
import Divider from "@material-ui/core/Divider";
import { AdiId, BankAccount___UnsafeUnwrap_Z2C38F894, VatNumber___UnsafeUnwrap_18C04ACB, AdiRoleModule_string, PersonIdOvam___UnsafeUnwrap_ZCAC45BA, NationalInsuranceNumber___UnsafeUnwrap_Z19EB54D4, PhoneNumber___UnsafeUnwrap_23E45174, Email___UnsafeUnwrap_Z27D11339, NonEmptyString___UnsafeUnwrap_Z73AD07C } from "../../../shared/Domain.fs.js";
import { map as map_1, defaultArg } from "../fable_modules/fable-library.3.7.17/Option.js";
import { join } from "../fable_modules/fable-library.3.7.17/String.js";
import { empty as empty_1, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library.3.7.17/Seq.js";
import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";
import { useSnackbar } from "notistack";
import { useFeliz_React__React_useState_Static_1505 } from "../fable_modules/Feliz.1.68.0/React.fs.js";
import { RouterModule_nav } from "../fable_modules/Feliz.Router.3.10.0/./Router.fs.js";
import { Page$2__toUrl_2B594 } from "../../../BidirectionalRouting/BidirectionalRouting.fs.js";
import { epcInspectors, epcInspectorEdit } from "../AppRoutes.fs.js";
import Edit from "@material-ui/icons/Edit";
import CheckBox from "@material-ui/icons/CheckBox";
import Delete from "@material-ui/icons/Delete";
import { useFeliz_React__React_useDeferred_Static_2344FC52 } from "../fable_modules/Feliz.UseDeferred.1.5.0/UseDeferred.fs.js";
import { Page } from "../components/Page.fs.js";
import { DisplayDeferred } from "../../../DesignSystems/DisplayDeferred.fs.js";
import { startImmediate } from "../fable_modules/fable-library.3.7.17/Async.js";
import { singleton as singleton_2 } from "../fable_modules/fable-library.3.7.17/AsyncBuilder.js";
import { EnqueueSnackbarOption, SnackbarProp_Variant_Z609E1E86, ProviderContext__enqueueSnackbar_Z1776A768 } from "../../../Notistack/Notistack.fs.js";

export function DisplayEpcInspectorInfo(inspector) {
    let elems, elems_1, elems_2, elems_3;
    const regions = map((r) => {
        switch (r.tag) {
            case 1: {
                return "East Flanders";
            }
            case 2: {
                return "Antwerp";
            }
            case 3: {
                return "Flemish Brabant";
            }
            case 4: {
                return "Limburg";
            }
            default: {
                return "West Flanders";
            }
        }
    }, inspector.Regions, {
        Compare: comparePrimitives,
    });
    let activeStatusChip;
    const patternInput = inspector.IsActive ? ["Actief", BkgColor.Primary] : ["Inactief", BkgColor.Danger];
    activeStatusChip = createElement("div", createObj(ofArray([Feliz_prop__prop_fss_Static_72C268A9(singleton(unitHelpers_CssRuleWithAutoLength__value_Z498FEB3B(MaxWidth, px(300)))), (elems = [MuiHelpers_createElement(Chip, [["label", `${patternInput[0]}`], ["clickable", false], ["classes.label", patternInput[1]]])], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
    return createElement(Col, {
        classes: singleton(Gap.L),
        children: ofArray([activeStatusChip, createElement(Row, {
            classes: singleton(Gap.L),
            children: ofArray([MuiHelpers_createElement(Paper, [Feliz_prop__prop_fss_Static_72C268A9(singleton(FlexClasses_FlexShrinkGrow__value_5E38073B(FlexGrow, 1))), (elems_1 = [createElement(Col, {
                classes: empty(),
                children: ofArray([createElement(InfoTitle, {
                    text: "Algemeen",
                }), MuiHelpers_createElement(Divider, []), createElement(DisplayData, {
                    data: ofArray([["Naam", NonEmptyString___UnsafeUnwrap_Z73AD07C(inspector.FirstName)], ["Voornaam", NonEmptyString___UnsafeUnwrap_Z73AD07C(inspector.LastName)], ["Emailadres", Email___UnsafeUnwrap_Z27D11339(inspector.Email)], ["Email We Check", Email___UnsafeUnwrap_Z27D11339(inspector.EmailAsbestConsulting)], ["Telefoon", PhoneNumber___UnsafeUnwrap_23E45174(inspector.PhoneNumber)], ["Rijksregisternummer", NationalInsuranceNumber___UnsafeUnwrap_Z19EB54D4(inspector.NationalInsuranceNumber)], ["Persoons-id OVAM/VEKA", defaultArg(map_1(PersonIdOvam___UnsafeUnwrap_ZCAC45BA, inspector.PersonIdOvam), "")], ["Role", defaultArg(map_1(AdiRoleModule_string, inspector.Role), "-")]]),
                })]),
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]), createElement(Col, {
                classes: ofArray([Gap.L, flexExpand]),
                children: ofArray([MuiHelpers_createElement(Paper, [Feliz_prop__prop_fss_Static_72C268A9(singleton(FlexClasses_FlexShrinkGrow__value_5E38073B(FlexGrow, 1))), (elems_2 = [createElement(Col, {
                    classes: empty(),
                    children: ofArray([createElement(InfoTitle, {
                        text: "Adres",
                    }), MuiHelpers_createElement(Divider, []), createElement(DisplayData, {
                        data: ofArray([["Straat", NonEmptyString___UnsafeUnwrap_Z73AD07C(inspector.Address.Street)], ["Nummer", NonEmptyString___UnsafeUnwrap_Z73AD07C(inspector.Address.Number)], ["Bus", defaultArg(map_1(NonEmptyString___UnsafeUnwrap_Z73AD07C, inspector.Address.Bus), "--")], ["Postcode", NonEmptyString___UnsafeUnwrap_Z73AD07C(inspector.Address.PostalCode)], ["Gemeente", NonEmptyString___UnsafeUnwrap_Z73AD07C(inspector.Address.City)]]),
                    })]),
                })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])]), MuiHelpers_createElement(Paper, [Feliz_prop__prop_fss_Static_72C268A9(singleton(FlexClasses_FlexShrinkGrow__value_5E38073B(FlexGrow, 1))), (elems_3 = [createElement(Col, {
                    classes: empty(),
                    children: ofArray([createElement(InfoTitle, {
                        text: "Regio(s) waar de EPC-deskundige werkzaam is",
                    }), MuiHelpers_createElement(Divider, []), createElement(DisplayData, {
                        data: singleton(["Regio(s)", join(", ", regions)]),
                    })]),
                })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])]),
            })]),
        }), createElement(Row, {
            classes: singleton(Gap.L),
            children: toList(delay(() => {
                let elems_4;
                return append(singleton_1(MuiHelpers_createElement(Paper, [Feliz_prop__prop_fss_Static_72C268A9(singleton(FlexClasses_FlexShrinkGrow__value_5E38073B(FlexGrow, 1))), (elems_4 = [createElement(Col, {
                    classes: empty(),
                    children: ofArray([createElement(InfoTitle, {
                        text: "Bedrijfsgegevens",
                    }), MuiHelpers_createElement(Divider, []), createElement(DisplayData, {
                        data: ofArray([["Ondernemingsnummer", VatNumber___UnsafeUnwrap_18C04ACB(inspector.AdiCompany.VatNumber)], ["Zichtrekening", BankAccount___UnsafeUnwrap_Z2C38F894(inspector.AdiCompany.BankAccount)], ["Betalingstermijn", `${inspector.AdiCompany.TermOfPayment}`], ["BTW-plichtig", inspector.AdiCompany.VatLiable ? "Ja" : "Nee"]]),
                    })]),
                })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])])), delay(() => {
                    let matchValue, co, elems_5, ctype;
                    return append((matchValue = inspector.AdiCompany.CompanyFormat, (matchValue.tag === 0) ? ((empty_1())) : ((co = matchValue.fields[0], singleton_1(MuiHelpers_createElement(Paper, [Feliz_prop__prop_fss_Static_72C268A9(singleton(FlexClasses_FlexShrinkGrow__value_5E38073B(FlexGrow, 1))), (elems_5 = [createElement(Col, {
                        classes: empty(),
                        children: ofArray([createElement(InfoTitle, {
                            text: "Gegevens vennootschap",
                        }), MuiHelpers_createElement(Divider, []), createElement(DisplayData, {
                            data: ofArray([["Naam vennootschap", NonEmptyString___UnsafeUnwrap_Z73AD07C(co.Name)], ["Vennootschapsvorm", (ctype = co.TypeOfCorporation, (ctype.tag === 1) ? "BV" : ((ctype.tag === 2) ? "CV" : ((ctype.tag === 3) ? "VOF" : ((ctype.tag === 4) ? "Single Proprietor" : "NV"))))], ["Telefoon", PhoneNumber___UnsafeUnwrap_23E45174(co.PhoneNumber)], ["Emailadres", Email___UnsafeUnwrap_Z27D11339(co.Email)]]),
                        })]),
                    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))])]))))), delay(() => {
                        let elems_6;
                        return singleton_1(MuiHelpers_createElement(Paper, [Feliz_prop__prop_fss_Static_72C268A9(singleton(FlexClasses_FlexShrinkGrow__value_5E38073B(FlexGrow, 1))), (elems_6 = [createElement(Col, {
                            classes: empty(),
                            children: ofArray([createElement(InfoTitle, {
                                text: "Adres zaak",
                            }), MuiHelpers_createElement(Divider, []), createElement(DisplayData, {
                                data: ofArray([["Straat", NonEmptyString___UnsafeUnwrap_Z73AD07C(inspector.AdiCompany.Address.Street)], ["Nummer", NonEmptyString___UnsafeUnwrap_Z73AD07C(inspector.AdiCompany.Address.Number)], ["Bus", defaultArg(map_1(NonEmptyString___UnsafeUnwrap_Z73AD07C, inspector.AdiCompany.Address.Bus), "--")], ["Postcode", NonEmptyString___UnsafeUnwrap_Z73AD07C(inspector.AdiCompany.Address.PostalCode)], ["Gemeente", NonEmptyString___UnsafeUnwrap_Z73AD07C(inspector.AdiCompany.Address.City)]]),
                            })]),
                        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_6))])]));
                    }));
                }));
            })),
        })]),
    });
}

export function ActivateStatusConfirmationModal(activateStatusConfirmationModalInputProps) {
    let elems_1;
    const onClick = activateStatusConfirmationModalInputProps.onClick;
    const setShowModal = activateStatusConfirmationModalInputProps.setShowModal;
    const showModal = activateStatusConfirmationModalInputProps.showModal;
    const label = activateStatusConfirmationModalInputProps.label;
    const adiId = activateStatusConfirmationModalInputProps.adiId;
    return MuiHelpers_createElement(Modal, [["open", showModal], ["onClose", (_arg_1, v) => {
        setShowModal(false);
    }], ["children", createElement("div", createObj(ofArray([["className", join(" ", [modal, PaddingTop.L, PaddingBottom.L, PaddingLeft.Xxl, PaddingRight.Xxl])], (elems_1 = [createElement("div", {
        className: join(" ", [MarginBottom.M]),
        children: Interop_reactApi.Children.toArray([label]),
    }), MuiHelpers_createElement(Button, [["onClick", (_arg_2) => {
        onClick(adiId);
    }], ["variant", "contained"], ["color", "secondary"], ["children", "Ja"]]), MuiHelpers_createElement(Button, [["onClick", (_arg_3) => {
        setShowModal(false);
    }], ["className", join(" ", [MarginLeft.S])], ["variant", "contained"], ["color", "primary"], ["children", "Nee"]])], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))]]);
}

export function EpcInspectorDetail(epcInspectorDetailInputProps) {
    let props, props_2, props_4;
    const inspectorId = epcInspectorDetailInputProps.inspectorId;
    const api = epcInspectorDetailInputProps.api;
    const currentPage = epcInspectorDetailInputProps.currentPage;
    const snackbar = useSnackbar();
    const patternInput = useFeliz_React__React_useState_Static_1505(false);
    const setShowDeactivateModal = patternInput[1];
    const patternInput_1 = useFeliz_React__React_useState_Static_1505(false);
    const setShowActivateModal = patternInput_1[1];
    const patternInput_2 = useFeliz_React__React_useState_Static_1505(true);
    const editButton = MuiHelpers_createElement(Button, [["onClick", (_arg_4) => {
        RouterModule_nav(ofArray(Page$2__toUrl_2B594(epcInspectorEdit, inspectorId)), 1, 1);
    }], ["variant", "contained"], ["color", "secondary"], ["startIcon", (props = {}, react.createElement(Edit, props))], ["children", "EPC-deskundige aanpassen"]]);
    const activateButton = (!patternInput_2[0]) ? MuiHelpers_createElement(Button, [["onClick", (_arg_5) => {
        setShowActivateModal(true);
    }], ["className", join(" ", [MarginLeft.S])], ["variant", "contained"], ["color", "secondary"], ["startIcon", (props_2 = {}, react.createElement(CheckBox, props_2))], ["children", "Activeer"]]) : MuiHelpers_createElement(Button, [["className", join(" ", [MarginLeft.S])], ["onClick", (_arg_6) => {
        setShowDeactivateModal(true);
    }], ["variant", "contained"], ["color", "secondary"], ["startIcon", (props_4 = {}, react.createElement(Delete, props_4))], ["children", "Deactiveer"]]);
    const data = useFeliz_React__React_useDeferred_Static_2344FC52(api.GetAdi(new AdiId(inspectorId)), []);
    return createElement(Page, {
        currentPage: currentPage,
        title: "EPC-deskundige persoonlijke gegevens",
        actions: [editButton, activateButton],
        children: [createElement(DisplayDeferred, {
            data: data,
            view: (inspector) => {
                let elems;
                if (inspector == null) {
                    return `Geen EPC-deskundige gevonden met ID ${inspectorId}`;
                }
                else {
                    const inspector_1 = inspector;
                    patternInput_2[1](inspector_1.IsActive);
                    return createElement("div", createObj(singleton((elems = [createElement(DisplayEpcInspectorInfo, inspector_1), createElement(ActivateStatusConfirmationModal, {
                        adiId: inspector_1.Id,
                        label: "Bent u zeker dat u deze EPC-deskundige wilt deactiveren?",
                        showModal: patternInput[0],
                        setShowModal: setShowDeactivateModal,
                        onClick: (adiId) => {
                            startImmediate(singleton_2.Delay(() => singleton_2.TryWith(singleton_2.Delay(() => singleton_2.Bind(api.DeactivateAdi(adiId), (_arg) => {
                                const result = _arg;
                                if (result.tag === 1) {
                                    ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. [${result.fields[0]}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                                    return singleton_2.Zero();
                                }
                                else {
                                    ProviderContext__enqueueSnackbar_Z1776A768(snackbar, "EPC-deskundige gedeactiveerd", SnackbarProp_Variant_Z609E1E86("success"), new EnqueueSnackbarOption(1, false));
                                    RouterModule_nav(ofArray(Page$2__toUrl_2B594(epcInspectors)), 1, 1);
                                    return singleton_2.Zero();
                                }
                            })), (_arg_1) => {
                                ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. [${_arg_1.message}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                                return singleton_2.Zero();
                            })));
                        },
                    }), createElement(ActivateStatusConfirmationModal, {
                        adiId: inspector_1.Id,
                        label: "Bent u zeker dat u deze EPC-deskundige wilt activeren?",
                        showModal: patternInput_1[0],
                        setShowModal: setShowActivateModal,
                        onClick: (adiId_1) => {
                            startImmediate(singleton_2.Delay(() => singleton_2.TryWith(singleton_2.Delay(() => singleton_2.Bind(api.ActivateAdi(adiId_1), (_arg_2) => {
                                const result_1 = _arg_2;
                                if (result_1.tag === 1) {
                                    ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. [${result_1.fields[0]}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                                    return singleton_2.Zero();
                                }
                                else {
                                    ProviderContext__enqueueSnackbar_Z1776A768(snackbar, "EPC-deskundige geactiveerd", SnackbarProp_Variant_Z609E1E86("success"), new EnqueueSnackbarOption(1, false));
                                    RouterModule_nav(ofArray(Page$2__toUrl_2B594(epcInspectors)), 1, 1);
                                    return singleton_2.Zero();
                                }
                            })), (_arg_3) => {
                                ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. [${_arg_3.message}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                                return singleton_2.Zero();
                            })));
                        },
                    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))]))));
                }
            },
        })],
    });
}

